import { motion } from 'framer-motion'
import { AlertTriangle, Brain, Users } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { pageUrl } from '../seo'

const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 }
}

// Um ícone por cartão, na ordem de consequencias.impacts no catálogo.
const ICONS = [AlertTriangle, Brain, Users]

export default function ConsequenciasEImpacto() {
    const { t } = useTranslation()
    const impacts = t('consequencias.impacts', { returnObjects: true })

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6 }}
            className="min-h-screen bg-white"
        >
            {/* SEO por rota — no React 19 estas tags são içadas para o <head> */}
            <title>{t('consequencias.metaTitle')}</title>
            <meta name="description" content={t('consequencias.metaDescription')} />
            <link rel="canonical" href={pageUrl('consequencias-e-impacto')} />
            {/* Hero Section */}
            <section
                className="relative overflow-hidden py-16 lg:py-20 bg-cover bg-center"
                style={{ backgroundImage: "url('/assets/images/hero-bg.jpg')" }}
            >
                <div className="absolute inset-0 bg-black/55" />
                <div className="container-custom relative z-10">
                    <motion.h1
                        initial={{ opacity: 0, y: 40 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.7, delay: 0.1 }}
                        className="text-4xl lg:text-6xl font-bold text-white leading-tight"
                    >
                        {t('consequencias.title')}
                    </motion.h1>
                </div>
            </section>

            {/* Impact Cards */}
            <section className="section-padding bg-slate-50">
                <div className="container-custom">
                    <div className="space-y-6">
                        {impacts.map((item, i) => {
                            const Icon = ICONS[i] ?? AlertTriangle
                            return (
                                <motion.div
                                    key={i}
                                    variants={fadeUp}
                                    initial="hidden"
                                    whileInView="visible"
                                    viewport={{ once: true }}
                                    transition={{ duration: 0.5, delay: i * 0.1 }}
                                    className="bg-brand-50 border-brand-100 border rounded-2xl p-7 hover:-translate-y-0.5 transition-transform duration-300 shadow-xs"
                                >
                                    <div className="inline-flex p-3 rounded-xl bg-gradient-to-br from-brand-500 to-brand-700 shadow-md mb-5">
                                        <Icon size={22} className="text-white" aria-hidden="true" />
                                    </div>
                                    <h2 className="text-xl font-bold text-slate-900 mb-4">{item.title}</h2>
                                    <p className="text-slate-700 leading-relaxed">{item.text}</p>
                                </motion.div>
                            )
                        })}
                    </div>
                </div>
            </section>
        </motion.div>
    )
}
